module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"edit_comment_label":"修改评论","delete_comment_label":"删除评论","delete_comment_confirmation":"确定要删除评论吗？"}}')
  delete Component.options._Ctor
}
